import classNames from "classnames";
import {PropsWithChildren} from "react";

import {MonitoringGroupLevel, MonitoringServer} from "@/lib/types/monitoring.ts";
import {PropsWithClassName} from "@/lib/types/props.ts";

import {isAvailable} from "../utils.ts";

interface MonitoringServerRowProps extends PropsWithClassName, PropsWithChildren {
  server: MonitoringServer;
  userMonitoringLevel?: MonitoringGroupLevel;
}

export const MonitoringServerRow = ({server, userMonitoringLevel, className, children}: MonitoringServerRowProps) => {
  return (
    <span className={classNames({"text-muted": !isAvailable(server, userMonitoringLevel)}, className)}>{children}</span>
  );
};
